import React from 'react';

import { TextField } from '@material-ui/core';

import style from '../../awbInfo/awbInfo.module.css';
import commonStyles from '../../common/common.module.css';

interface GeneralRemarksProps {
  generalRemarks: string;
};

const TEXT_FIELD_PADDINGS: string = '10px 6px 10px 10px';
const TEXT_FIELD_WIDTH: string = '100%';
const SELECT_FONT_SIZE: string = '13px';

const generalRemarksView = (props: GeneralRemarksProps) => {

  return (
    <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
      <h3 className={ `${ commonStyles.header }` } >General Remarks</h3>
      <div className={style.inputsWrapper } >
          { props.generalRemarks }
       </div>   
    </div>
  );
}

export default generalRemarksView;